import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  name: EMPTY_STRING,
  description: EMPTY_STRING,
};
